/*
 *
 *  Router
 */

// deps
import Vue from 'vue'
import Router from 'vue-router'
import aos from '@/plugins/aos'

// use router
Vue.use(Router)

// pages
const Home = () => import(/* webpackChunkName: "home" */ '@/views/Home')
const Contact = () => import(/* webpackChunkName: "contact" */ '@/views/Contact')
const Team = () => import(/* webpackChunkName: "team" */ '@/views/Team')

// services
const ServicesBase = () => import(/* webpackChunkName: "Services" */ '@/views/services/ServicesBase')

// status pages
const Error404 = () => import(/* webpackChunkName: "global" */ '@/views/Error404')

// disable scroll restoration
if ('scrollRestoration' in history) {
  history.scrollRestoration = 'manual'
}

// router
const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior(to, from, savedPosition) {
    return new Promise(resolve => {
      return setTimeout(() => {
        if (savedPosition) {
          resolve(savedPosition)
        } else if (to.hash) {
          resolve({ selector: to.hash })
        } else {
          resolve({ x: 0, y: 0 })
        }
      }, 500)
    })
  },
  routes: [
    /*
     * Catch all 404 / 404
     */
    {
      path: '*',
      redirect: { name: '404' }
    },
    {
      path: '/404',
      name: '404',
      component: Error404,
      meta: { title: '404', transitionName: 'trans' }
    },
    /*
     * Home
     */
    {
      path: '/',
      name: 'Home',
      component: Home,
      meta: { title: 'الرئيسية', breadcrumbIcon: 'mdi-home', transitionName: 'trans' }
    },
    /*
     * Contact
     */
    {
      path: '/contact',
      name: 'Contact',
      component: Contact,
      meta: { title: 'تواصل معنا', transitionName: 'trans' }
    },
    /*
     * Contact
     */
    {
      path: '/team',
      name: 'Team',
      component: Team,
      meta: { title: 'فريقنا', transitionName: 'trans' }
    },
    /*
     * Services Base
     */
    {
      path: '/services/:serviceName',
      name: 'ServicesBase',
      component: ServicesBase,
      props: true,
      meta: {
        title: 'خدمة',
        transitionName: 'trans'
      }
    }
  ]
})

/*
 *
 *  Handle Redirects
 */

router.beforeEach((to, _from, next) => {
  // go to next if doesn't have redirect
  if (!to.redirectedFrom) {
    next()
    return
  }
  // set routes
  const routes = [
    {
      path: 'services',
      redirect: { name: 'Home' }
    },
    {
      path: 'clients',
      redirect: { name: 'Home' }
    },
    {
      path: 'studios-hire',
      redirect: { name: 'ServicesBase', params: { serviceName: 'studios' } }
    }
  ]
  // loop and redirect to route path
  routes.forEach(route => {
    if (to.redirectedFrom.includes(route.path)) {
      next(route.redirect)
      return
    }
  })
  // go to next
  next()
})

/*
 *
 *  Update Aos After Each Route
 */

router.afterEach(() => {
  // refresh aos
  setTimeout(() => {
    aos.refresh()
  }, 2000)
})

// export
export default router
